import { AxiosInstance } from 'axios';
import AxiosRepository from './axios.repository';
import {
  IAccountRepository,
  ILocationsListParams,
  IUsersListParams,
  LocationPayload,
  UserCreationPayload,
  UserPatchPayload,
} from '@common/interfaces';
import { decoupledClientInstance } from '@common/utils/axios';

class AccountRepository extends AxiosRepository implements IAccountRepository {
  public constructor(protected authClient: AxiosInstance) {
    super((decoupledClientInstance as any).create(), authClient);
  }

  async getCurrentUser() {
    const { data } = await this.get('/accounts/me/');
    return data;
  }

  async getUsers(params?: IUsersListParams) {
    const { data } = await this.get('/accounts/user-management/', { params });
    return data;
  }

  async createUser(payload: UserCreationPayload) {
    const { data } = await this.post('/accounts/user-management/pre-register/', payload);
    return data;
  }

  async patchUser(uuid: string, payload: UserPatchPayload) {
    const { data } = await this.patch(`/accounts/user-management/${uuid}/`, payload);
    return data;
  }

  async getUsersFilters() {
    const { data } = await this.get('/accounts/user-management/filters/');
    return data;
  }

  async getUsersOptions() {
    const { data } = await this.get('/accounts/user-management/pre-register/options/');
    return data;
  }

  async exportUsers() {
    const { data } = await this.get('/accounts/user-management/export/', {
      responseType: 'blob',
    });
    return new File([data], `users_list.xls`);
  }

  async getLocations(params?: ILocationsListParams) {
    const { data } = await this.get('/accounts/user-location/', { params });
    return data;
  }

  async createLocation(payload: LocationPayload) {
    const { data } = await this.post('/accounts/user-location/', payload);
    return data;
  }

  async patchLocation(uuid: string, payload: LocationPayload) {
    const { data } = await this.patch(`/accounts/user-location/${uuid}/`, payload);
    return data;
  }

  async getLocationsFilters() {
    const { data } = await this.get('/accounts/user-location/filters/');
    return data;
  }

  async getLocationsOptions() {
    const { data } = await this.get('/accounts/user-location/options/');
    return data;
  }
}

export default AccountRepository;
